export default __webpack_public_path__ + "static/media/Definix-Trading-Challenge-12.87179b57.png";